var render = function render(){
  var _vm$item;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.readonly ? _c('span', [_vm._v(" " + _vm._s(((_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.name) || "-") + " ")]) : _c('v-autocomplete', _vm._b({
    attrs: {
      "value": _vm.value
    },
    on: {
      "change": function (changedValue) {
        return _vm.$emit('input', changedValue);
      },
      "click": _vm.alert
    }
  }, 'v-autocomplete', Object.assign({}, _vm.$attrs, {
    items: _vm.items,
    itemText: _vm.itemText,
    itemValue: '_id',
    multiple: _vm.multiple
  }), false), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }